<template>
  <div class="animated-element" :class="{ visible: isVisible }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      const rect = this.$el.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const isScrollingDown = window.scrollY > this.lastScrollPosition;
      this.lastScrollPosition = window.scrollY;
      if (rect.top >= 0 && rect.bottom <= windowHeight) {
        if (!this.isVisible || (!isScrollingDown && this.isVisible)) {
          this.isVisible = true;
        }
      } else {
        this.isVisible = false;
      }
    }
  }
};
</script>

<style scoped>
@keyframes bounce {
  0% {
    opacity: 0;
    transform: translateY(80px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animated-element {
  opacity: 0;
}

.animated-element.visible {
  animation: bounce 1s;
  opacity: 1;
}
</style>
